export const providers = [
  {
    id: 1,
    name: 'Carlos Rodríguez',
    category: 'Electricidad',
    categoryId: 1,
    description: 'Electricista certificado con más de 15 años de experiencia en instalaciones residenciales y comerciales. Especializado en sistemas de iluminación LED, tableros eléctricos y automatización del hogar.',
    basePrice: 45,
    rating: 4.9,
    reviewCount: 127,
    available: true,
    image: 'https://public.readdy.ai/ai/img_res/6049d21090034ffb8eccb5afe6d3d681.jpg',
    completedJobs: 342,
    responseTime: '30 min',
    skills: ['Instalaciones eléctricas', 'Reparaciones', 'Iluminación LED', 'Automatización']
  },
  {
    id: 2,
    name: 'María González',
    category: 'Limpieza',
    categoryId: 2,
    description: 'Servicio profesional de limpieza con equipo especializado y productos ecológicos. Atención al detalle y compromiso con la satisfacción del cliente en cada trabajo.',
    basePrice: 35,
    rating: 4.8,
    reviewCount: 203,
    available: true,
    image: 'https://readdy.ai/api/search-image?query=Professional%20cleaning%20service%20worker%20in%20uniform%20with%20cleaning%20supplies%20and%20equipment%20smiling%20confidently%20in%20a%20bright%20clean%20modern%20space%20professional%20portrait%20photography%20high%20quality&width=400&height=400&seq=provider2&orientation=squarish',
    completedJobs: 518,
    responseTime: '15 min',
    skills: ['Limpieza profunda', 'Desinfección', 'Productos ecológicos', 'Limpieza post-obra']
  },
  {
    id: 3,
    name: 'Juan Martínez',
    category: 'Jardinería',
    categoryId: 3,
    description: 'Jardinero profesional especializado en diseño de paisajes y mantenimiento de áreas verdes. Conocimiento experto en plantas nativas y sistemas de riego eficientes.',
    basePrice: 40,
    rating: 4.7,
    reviewCount: 89,
    available: false,
    image: 'https://readdy.ai/api/search-image?query=Professional%20gardener%20in%20work%20clothes%20with%20gardening%20tools%20and%20plants%20in%20a%20beautiful%20garden%20setting%20natural%20lighting%20professional%20portrait%20photography%20high%20quality&width=400&height=400&seq=provider3&orientation=squarish',
    completedJobs: 256,
    responseTime: '45 min',
    skills: ['Diseño de jardines', 'Poda', 'Sistemas de riego', 'Mantenimiento']
  },
  {
    id: 4,
    name: 'Ana López',
    category: 'Plomería',
    categoryId: 4,
    description: 'Plomera certificada con experiencia en reparaciones de emergencia y nuevas instalaciones. Disponible para servicios urgentes las 24 horas.',
    basePrice: 50,
    rating: 4.9,
    reviewCount: 156,
    available: true,
    image: 'https://readdy.ai/api/search-image?query=Professional%20female%20plumber%20in%20work%20uniform%20with%20plumbing%20tools%20and%20equipment%20confident%20pose%20in%20modern%20clean%20workspace%20professional%20portrait%20photography%20high%20quality&width=400&height=400&seq=provider4&orientation=squarish',
    completedJobs: 423,
    responseTime: '20 min',
    skills: ['Reparaciones urgentes', 'Instalaciones', 'Detección de fugas', 'Calentadores']
  },
  {
    id: 5,
    name: 'Pedro Sánchez',
    category: 'Pintura',
    categoryId: 5,
    description: 'Pintor profesional con ojo para el detalle y acabados impecables. Especializado en técnicas decorativas y restauración de superficies.',
    basePrice: 38,
    rating: 4.6,
    reviewCount: 94,
    available: true,
    image: 'https://readdy.ai/api/search-image?query=Professional%20painter%20in%20clean%20work%20clothes%20with%20painting%20tools%20and%20color%20samples%20in%20a%20bright%20modern%20space%20professional%20portrait%20photography%20high%20quality&width=400&height=400&seq=provider5&orientation=squarish',
    completedJobs: 287,
    responseTime: '1 hora',
    skills: ['Pintura interior', 'Pintura exterior', 'Técnicas decorativas', 'Restauración']
  },
  {
    id: 6,
    name: 'Laura Fernández',
    category: 'Carpintería',
    categoryId: 6,
    description: 'Carpintera especializada en muebles a medida y restauración de piezas antiguas. Trabajo artesanal de alta calidad con maderas nobles.',
    basePrice: 55,
    rating: 4.8,
    reviewCount: 72,
    available: true,
    image: 'https://readdy.ai/api/search-image?query=Professional%20female%20carpenter%20in%20workshop%20with%20woodworking%20tools%20and%20custom%20furniture%20pieces%20clean%20organized%20space%20professional%20portrait%20photography%20high%20quality&width=400&height=400&seq=provider6&orientation=squarish',
    completedJobs: 198,
    responseTime: '2 horas',
    skills: ['Muebles a medida', 'Restauración', 'Instalaciones', 'Diseño']
  },
  {
    id: 7,
    name: 'Roberto Díaz',
    category: 'Aire Acondicionado',
    categoryId: 7,
    description: 'Técnico certificado en sistemas de climatización. Instalación, mantenimiento y reparación de equipos de todas las marcas.',
    basePrice: 48,
    rating: 4.7,
    reviewCount: 118,
    available: false,
    image: 'https://readdy.ai/api/search-image?query=Professional%20HVAC%20technician%20with%20air%20conditioning%20equipment%20and%20tools%20in%20uniform%20clean%20modern%20workspace%20professional%20portrait%20photography%20high%20quality&width=400&height=400&seq=provider7&orientation=squarish',
    completedJobs: 334,
    responseTime: '1 hora',
    skills: ['Instalación', 'Mantenimiento', 'Reparaciones', 'Carga de gas']
  },
  {
    id: 8,
    name: 'Sofia Ramírez',
    category: 'Cerrajería',
    categoryId: 8,
    description: 'Cerrajera profesional disponible para emergencias. Apertura de puertas, cambio de cerraduras y sistemas de seguridad.',
    basePrice: 42,
    rating: 4.9,
    reviewCount: 145,
    available: true,
    image: 'https://readdy.ai/api/search-image?query=Professional%20female%20locksmith%20with%20lock%20tools%20and%20security%20equipment%20confident%20pose%20in%20clean%20modern%20workspace%20professional%20portrait%20photography%20high%20quality&width=400&height=400&seq=provider8&orientation=squarish',
    completedJobs: 412,
    responseTime: '25 min',
    skills: ['Apertura de emergencia', 'Cambio de cerraduras', 'Llaves codificadas', 'Seguridad']
  }
];